<template lang='pug'>
    v-card( dark )
        v-card-text( class="py-5" )
            h6.display-2 Módulo Ventas
            span.subheading Productos, clientes, ofertas, vendedores y reportes
</template>

<script>
    //
    import { mapActions } from 'vuex'
    //
    import { ModulesGrid } from '@/components/reusable_components/next'
    //
    export default {
        name: 'welcome',
        components: {
            'custom-grid-modules': ModulesGrid,
        },
        data () {
            return {
                items: [
                    {
                        title: 'Clientes',
                        items: [
                            {
                                color: 'accent',
                                route: {
                                    name: 'customers_list',
                                },
                                title: 'Ir al listado de clientes',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'customers_create',
                                },
                                title: 'Crear cliente',
                            },
                        ]
                    },
                    {
                        title: 'Ofertas',
                        items: [
                            {
                                color: 'accent',
                                route: {
                                    name: 'offers_list',
                                },
                                title: 'Ir al listado de ofertas',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'offers_create',
                                },
                                title: 'Crear oferta',
                            },
                        ]
                    },
                    {
                        title: 'Vendedores',
                        items: [
                            {
                                color: 'accent',
                                route: {
                                    name: 'users_list',
                                },
                                title: 'Ir al listado de vendedores',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'users_create',
                                },
                                title: 'Crear vendedor',
                            },
                        ]
                    },
                    {
                        title: 'Productos',
                        items: [
                            {
                                color: 'accent',
                                route: {
                                    name: 'products_list',
                                },
                                title: 'Ir al listado de productos',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'products_create',
                                },
                                title: 'Crear producto',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'promos_list',
                                },
                                title: 'Listado de promociones',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'promos_create',
                                },
                                title: 'Crear promoción',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'products_sale_price',
                                },
                                title: 'Modificar precios de venta',
                            },
                        ]
                    },
                    {
                        title: 'Comisiones',
                        items: [
                            {
                                color: 'accent',
                                route: {
                                    name: 'commission_list',
                                },
                                title: 'Ir al listado de comisiones',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'commission_create',
                                },
                                title: 'Crear comisión',
                            },
                        ]
                    },
                    {
                        title: 'Familias',
                        items: [
                            {
                                color: 'accent',
                                route: {
                                    name: 'families_list',
                                },
                                title: 'Ir al listado de familias',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'families_create',
                                },
                                title: 'Crear familia',
                            },
                        ]
                    },
                    {
                        title: 'Etiquetas',
                        items: [
                            {
                                color: 'accent',
                                route: {
                                    name: 'tags_list',
                                },
                                title: 'Ir al listado de etiquetas',
                            },
                            {
                                color: 'secondary',
                                route: {
                                    name: 'tags_create',
                                },
                                title: 'Crear etiqueta',
                            },
                        ]
                    },
                ]
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', {
                setTitleTopBar: 'setTitleTopBar',
            }),
        },
        mounted () { 
            this.setTitleTopBar( 'Inicio' )
        },
    }
</script>
